module.exports = __webpack_public_path__ + "img/chalk_3.b6414af5.png";